const postLogout = async () => {
  try {
    const response = await fetch('/api/jarvis/auth/logout', {
      method: 'POST',
    })

    return response.ok
  } catch {
    // Swallow network errors – we'll still redirect the user.
    return false
  }
}

const redirect = (destination: string) => {
  if (typeof window !== 'undefined') {
    window.location.href = destination
  }
}

export const logout = async (returnTo?: string) => {
  const didLogout = await postLogout()
  // Only honor custom destinations when the logout request succeeds.
  redirect(didLogout && returnTo ? returnTo : '/')
}

export const forceLogout = async (returnTo?: string) => {
  const didLogout = await postLogout()
  redirect(didLogout && returnTo ? returnTo : '/login')
}
